import script from "./ChartHeatMapPaper.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartHeatMapPaper.vue?vue&type=script&setup=true&lang=js"

import "./ChartHeatMapPaper.vue?vue&type=style&index=0&id=b227f080&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b227f080"]])

export default __exports__